import { GET, POST } from './API';

const PATH_ROOT = 'U015';

export type A01Input = {
  user_id: string;
  lang: string;
};
export type A01Output = {
  privacy_notice_approved: string;
  term_of_service_approved: string;
};
export async function A01(input: A01Input, cancellation?: AbortSignal): Promise<A01Output> {
  const param = new URLSearchParams();
  param.append('user_id', input.user_id);
  param.append('lang', input.lang);
  return await GET(`${PATH_ROOT}/consent_version?${param.toString()}`, cancellation);
}

export type A02Input = {
  lang: string;
  consent_type: string;
};
export type A02Output = {
  consent: string;
  revision: string;
};
export async function A02(input: A02Input, cancellation?: AbortSignal): Promise<A02Output> {
  const param = new URLSearchParams();
  param.append('lang', input.lang);
  param.append('consent_type', input.consent_type);
  return await GET(`${PATH_ROOT}/consent?${param.toString()}`, cancellation);
}

export type A04Input = {
  user_id: string;
  consent_type: string;
  revision: string;
};
export type A04Output = {
  status: string;
  msgid: string;
};
export async function A04(input: A04Input, cancellation?: AbortSignal): Promise<A04Output> {
  return await POST(
    `${PATH_ROOT}/accept_consent`,
    {
      user_id: input.user_id,
      consent_type: input.consent_type,
      revision: input.revision,
    },
    false,
    cancellation
  );
}
